<template>
    <div class="wrapper">
        <div class="container">
            <div class="page-logo">
                <a class="brand" href="#" @click.prevent="">
                    <img src="https://s3.amazonaws.com/tab-assets/logo_mcenter.svg" alt="logo"/>
                </a>
            </div>

            <v-portlet class="page-body">
                <div slot="body">
                    <div class="login-content">
                        <div class="row">
                            <!-- Tuango Traditional -->
                            <!--<div class="col-sm-6">-->
                                <!--<div class="column-container border-active">-->
                                    <!--<div class="login-table-head bg-blue">-->
                                        <!--<h2 class="no-margin">Tuango Traditional</h2>-->
                                    <!--</div>-->
                                    <!--<div class="arrow-down border-top-blue"></div>-->
                                    <!--<div class="login-table">-->
                                        <!--<div class="pic round">-->
                                            <!--<img src="/static/img/traditional.png"-->
                                                 <!--class="img-responsive" alt="">-->
                                        <!--</div>-->
                                    <!--</div>-->
                                    <!--<div class="login-table-content">-->
                                        <!--<div class="row mobile-padding">-->
                                            <!--<div class="col-xs-12 mobile-padding">$30,000</div>-->
                                        <!--</div>-->
                                        <!--<div class="row mobile-padding">-->
                                            <!--<div class="col-xs-12 mobile-padding">Total coupons sales</div>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                    <!--<div class="arrow-down arrow-grey"></div>-->
                                    <!--<div class="login-table-footer">-->
                                        <!--<button type="button"-->
                                                <!--class="btn blue btn-outline sbold uppercase login-button"-->
                                                <!--@click="$router.push({name: 'home.index', params: {section: 'traditional'}})">-->
                                            <!--Enter-->
                                        <!--</button>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!-- End Tuango Traditional -->

                            <!-- Tuango Plus -->
                            <div class="col-sm-6 col-sm-offset-3">
                                <div class="column-container border-active">
                                    <div class="login-table-head bg-red">
                                        <h2 class="no-margin">{{ $t('startPage.APP_NAME') }}</h2>
                                    </div>
                                    <div class="arrow-down border-top-red"></div>
                                    <div class="login-table">
                                        <div class="pic">
                                            <img src="/static/img/card-linked.png"
                                                 class="img-responsive" alt="">
                                        </div>
                                    </div>
                                    <div class="login-table-content">
                                        <div class="login-table-content">
                                            <div class="row mobile-padding">
                                                <div class="col-xs-12 mobile-padding">
                                                    $
                                                    <i-count-up
                                                            :start="0"
                                                            :end="totalSales"
                                                            :duration="2.5">
                                                    </i-count-up>
                                                </div>
                                            </div>
                                            <div class="row mobile-padding">
                                                <div class="col-xs-12 mobile-padding">{{ $t('startPage.TOTAL_TAB_SALES') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="arrow-down arrow-grey"></div>
                                    <div class="login-table-footer">
                                        <button type="button"
                                                class="btn red btn-outline login-button sbold uppercase"
                                                @click="$router.push({name: 'clo.dashboard', params: {section: 'clo'}})">
                                            {{ $t('startPage.ENTER') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!-- End Tuango Plus -->
                        </div>
                    </div><!-- /.login-content -->
                </div><!-- /.portlet-body -->
            </v-portlet>

        </div><!-- /.container -->
    </div><!-- /.wrapper -->
</template>
<script>
  /* ============
   * Start Index Page
   * ============
   *
   */
  import ICountUp from 'vue-countup-v2'

  import VPortlet from '@/app/components/Portlet'
  import GeneralStatsTransformer from '@/app/transformers/GeneralStatsTransformer'

  export default {
    /**
     * The name of the page.
     */
    name: 'start-index',
    components: {
      ICountUp,
      VPortlet
    },
    data () {
      return {
        stats: {
          lifetimeAvg: 0,
          lifetimeClaims: 0,
          lifetimeSales: 0,
          lifetimeTrx: 0
        }
      }
    },
    computed: {
      totalSales () {
        return +parseInt(this.stats.lifetimeSales)
      }
    },
    methods: {
      updateStats (id) {
        this.$api.userstatsIdGet({
          id
        })
          .then(res => {
            this.stats = Object.assign({}, this.stats, GeneralStatsTransformer.fetch(res.data))
          })
          .catch(err => console.log(err))
      }
    },
    created () {
      if (this.$store.state.account.id) {
        this.updateStats(this.$store.state.account.id)
      } else {
        const context = this
        this.$store.watch(
          function (state) {
            return state.account.id
          },
          function (val) {
            context.updateStats(val)
          }
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_mixins'; // global mixings.

    .wrapper {
        @media(min-width: 768px) {
            height: 100vh;
            display: flex;
            align-items: center;
        }
    }

    .page-logo {
        width: 200px;
        margin: 0 auto;
        padding: 20px 0 30px;
        text-align: center;

        img {
            display: block;
            width: 100%;
        }
    }

    .login-content {
        @include clearfix();

        background-color: transparent;

        .arrow-down {
            width: 0;
            height: 0;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            border-top: 15px solid;
            margin: auto;

            &.arrow-blue {
                border-top-color: #3598DC;
            }

            &.arrow-green {
                border-top-color: #32C5D2;
            }

            &.arrow-dark {
                border-top-color: #2F353B;
            }

            &.arrow-grey {
                border-top-color: #f7f9fb;
            }
        }

        .login-title {
            border-bottom: 1px solid;
            border-color: #fff;

            > h1 {
                margin: 20px 0;
            }
        }

        .column-container {
            text-align: center;
            margin: 0;
            background-color: #fff;
            box-shadow: 0 0 12px rgba(0, 0, 0, 0.5);

            @media (max-width: 767px) {
                margin-bottom: 20px;
            }

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        }

        .login-table-head {
            color: #fff;
            padding: 20px 0;

            h2 {
                font-size: 26px;
            }

            &.login-1 {
                background-color: #3598DC;
            }

            &.login-2 {
                background-color: #32C5D2;
            }

            &.login-3 {
                background-color: #2F353B;
            }
        }

        .login-table {
            > h3 {
                font-size: 60px;
                position: relative;

                > .login-sign {
                    font-size: 24px;
                    margin-left: -15px;
                    vertical-align: top;
                    top: 15px;
                }
            }

            > p {
                margin-top: 0;
            }

        }

        .login-table-content {
            background-color: #f7f9fb;
            color: #5c6d7e;
            font-weight: 600;
            font-size: 18px;

            .row {
                padding-top: 3px;
                padding-bottom: 3px;

                i {
                    color: #6cade6;
                }

                &:first-child {
                    font-size: 22px;
                    padding-top: 20px;
                }

                &:last-child {
                    padding-bottom: 20px;
                }
            }
        }

        .login-table-footer {
            padding: 20px 0;

            > .login-button {
                font-weight: bold;
                padding: 10px 20px;
            }
        }

        .pic {
            margin: 20px 0;

            > img {
                float: none;
                margin: 0 auto;
                max-width: 50%;
                border-radius: 50% !important;
            }
        }

        // Mobile styles
        @media (max-width: 1024px) {
            .mobile-padding {
                padding: 0;
                margin: 0;

                > i {
                    margin-right: 5px;
                }
            }

            .login-table-content {
                padding-left: 10px;
                padding-right: 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/app/pages/Start/Index.vue